import { RootState } from '@beam-app/types';
import { EquipmentsMap } from '@store/machines/equipmentsPicker.schema';
import { pick } from '@utils/pick';
import { NeededFromEq, SHARED_FIELDS } from '../OnBoardingModal.utils';
import { EquipmentTypeKeepNulls } from '../types';
import { mergeFields } from './mergeFields';

export function mapSinglesToEquipments(
  values: Partial<EquipmentTypeKeepNulls>[],
  equipments: EquipmentsMap,
  knownData: RootState['knownData'],
): EquipmentsMap {
  const freshMap = new Map(equipments);

  const transformed: NeededFromEq[] = values.map(value => {
    const old = freshMap.get(value.id as string) as NeededFromEq; // must exist.
    // Value includes undefined until we json.stringiy
    const shared = pick(value, SHARED_FIELDS);
    let {
      equipmentStatus,
      manufacturerImg,
      manufacturerName,
      product,
      user,
      fields,
      tags,
    } = old;
    if (value.equipmentStatusId) {
      equipmentStatus = knownData.knownStatuses[value.equipmentStatusId];
    }

    if (value.productId) {
      ({
        manufacturerImg = manufacturerImg,
        manufacturerName = manufacturerName,
        ...product
      } = knownData.knownProducts[value.productId]);
    }
    if (value.userId) {
      user = knownData.knownUsers[value.userId];
    }
    if (value.tagsId) {
      tags = value.tagsId.map(tagId => knownData.knownTags[tagId]);
    }
    if (value.customFields) {
      fields = mergeFields(fields, value.customFields);
    }
    return {
      ...old,
      ...shared,
      product,
      equipmentStatus,
      manufacturerImg,
      manufacturerName,
      user,
      tags,
      fields,
    };
  });
  transformed.forEach(value => freshMap.set(value.id, value));
  return freshMap;
}
